import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import ReactHtmlParser, { processNodes } from 'react-html-parser';
import { Link } from 'react-router-dom';
import { Element } from 'react-scroll';
import { APP_BASE_URL } from '../../define/env';
import { blockStyle, noneStyle } from '../../helpers/common';
import { propBool, propFunc, propNumber, propShape, } from '../../helpers/custom-prop-types';
import RegistrationLink from '../Ui/Registration/RegistrationLink';
class FaqContentItem extends React.Component {
    constructor() {
        super(...arguments);
        this.toggle = () => {
            const { changeIsShow, item, tabNo } = this.props;
            changeIsShow(tabNo, item.question);
        };
        // eslint-disable-next-line consistent-return
        this.transform = (node, index) => {
            if (node.type === 'tag' && node.name === 'a' && node.attribs.href) {
                const { href } = node.attribs;
                const regex = `^${APP_BASE_URL}`;
                const { onLinkClick } = this.props;
                if (!href.match(regex)) {
                    return processNodes(node.children, this.transform);
                }
                const to = href.replace(new RegExp(regex), '');
                const page = to.split(/[?#/]/)[1];
                switch (page) {
                    case 'registration': {
                        return (_jsx(RegistrationLink, { href: to, text: processNodes(node.children, this.transform) }, index));
                    }
                    case 'faq': {
                        const hash = to.substr(to.indexOf('#') + 1);
                        const tab = hash.split('_')[0];
                        const question = hash.split('_')[1];
                        return (_jsx("a", Object.assign({ href: to, onClick: (e) => {
                                e.preventDefault();
                                onLinkClick(tab, question);
                            } }, { children: processNodes(node.children, this.transform) }), index));
                    }
                    default: {
                        return (_jsx(Link, Object.assign({ to: to }, { children: processNodes(node.children, this.transform) }), index));
                    }
                }
            }
        };
    }
    render() {
        const { isShow, item, tabNo } = this.props;
        return (_jsxs("div", Object.assign({ className: 'qa-box' }, { children: [_jsxs("div", Object.assign({ className: `qa-box-q js-accordion-trigger ${isShow ? 'on' : ''}`, onClick: this.toggle, role: 'presentation' }, { children: [item.question, _jsx("i", { className: 'material-icons accordion-icon' })] })), _jsx(Element, Object.assign({ className: `qa-box-a ${isShow ? 'is-opened' : ''}`, name: `${tabNo}_${item.question}` }, { children: _jsx("div", Object.assign({ className: 'accordion-sub', style: isShow ? blockStyle : noneStyle }, { children: _jsx("p", { children: ReactHtmlParser(renderToStaticMarkup(item.answer), {
                                transform: this.transform,
                            }) }) })) }))] })));
    }
}
FaqContentItem.propTypes = {
    changeIsShow: propFunc().isRequired,
    isShow: propBool(),
    item: propShape().isRequired,
    onLinkClick: propFunc().isRequired,
    tabNo: propNumber().isRequired,
};
FaqContentItem.defaultProps = {
    isShow: false,
};
export default FaqContentItem;
